import type { MaterialSymbolProps } from './MaterialSymbol.types'

export const MaterialSymbol = ({ icon: Icon, size = 24, className, label }: MaterialSymbolProps) =>
  label ? (
    <Icon
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      focusable="false"
      role="img"
      aria-label={label}
    />
  ) : (
    <Icon
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      focusable="false"
      aria-hidden="true"
    />
  )
